import { render, staticRenderFns } from "./CurriculumEntryForm.vue?vue&type=template&id=1b975f17&scoped=true&"
import script from "./CurriculumEntryForm.vue?vue&type=script&lang=js&"
export * from "./CurriculumEntryForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms.css?vue&type=style&index=0&id=1b975f17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b975f17",
  null
  
)

export default component.exports